module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_location-f991a6613bae556d7578e1bc12bcb426.webp";